export const INITIALS = "Cryptolinx.io/"